export default {
  items: [
    /*
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Financeiro',
      url: '/financeiro',
      icon: 'cui-dollar'
    }
      */
  ]
}



// WEBPACK FOOTER //
// ./src/_navView.js